import { createContext } from 'react';

const TutorsContext = createContext();

export default TutorsContext;
